export default __webpack_public_path__ + "static/media/Star 1.62614efa.png";